export default __webpack_public_path__ + "static/investing-channel-1bc8c213a8b6051466bee6e9022385e7.png";